module.exports = new __parcel__URL__("github.001ea2d1.svg").toString();